import React, { HTMLAttributes } from 'react'
import { ReleaseConsumerIdentityComponent } from '#src/generated/graphql'
import { IdentityConsumer } from '#src/containers/Identity'

interface ReleaseConsumerIdentityLinkProps extends HTMLAttributes<HTMLAnchorElement> {}

const ReleaseConsumerIdentityLink: React.SFC<ReleaseConsumerIdentityLinkProps> = props => {
  return (
    <IdentityConsumer>
      {({ myself, refetch: refetchIdentity }) =>
        myself && refetchIdentity ? (
          <ReleaseConsumerIdentityComponent>
            {releaseConsumerIdentity => (
              <a
                onClick={() => releaseConsumerIdentity().then(() => refetchIdentity())}
                {...props}
              />
            )}
          </ReleaseConsumerIdentityComponent>
        ) : null
      }
    </IdentityConsumer>
  )
}

export default ReleaseConsumerIdentityLink
